import { ISalesTeamCoverage } from 'legacy/lut/classes/models/salesTeam'

import { IBPOverviewSalesAgentView } from 'clickNgo/models/crud/views'

export const mapSalesTeamCoverageFrom606Crud = (
  data: IBPOverviewSalesAgentView
): ISalesTeamCoverage => ({
  assignmentPeriod: data.AssignmentPeriod || '',
  businessUnit: data.Business_Unit || '',
  created: data.Created || '',
  createdBy: data.CreatedBy || '',
  email: data.Email || '',
  entryId: data.EntryId || 0,
  firstName: data.First_Name || '',
  l4Manager: data.L4Manager || '',
  lastName: data.Last_Name || '',
  isLeadPBM: Boolean(data.LeadPBM),
  managerEmail: data.ManagerEmail || '',
  modified: data.Modified || '',
  modifiedBy: data.ModifiedBy || '',
  partnerId: data.Partner_ID || '',
  region: data.GeoRegion || '',
  roles: data.Roles || '',
  source: data.Source || '',
  sortOrderByRole:
    typeof data.SortOrderByRole === 'number' && !isNaN(data.SortOrderByRole)
      ? data.SortOrderByRole
      : 999,
})
